module.exports = __webpack_public_path__ + "fonts/benchnine-v9-latin-regular.3e78abf8.woff2";